
<template>
  <div>
    <v-card flat>
      <v-card-title class="d-flex align-center justify-end">
        <template v-if="editing">
          <v-autocomplete
            v-model="selected_employee_ids"
            :items="available_employees"
            item-text="attributes.name"
            item-value="id"
            label="Funcionários para adicionar"
            :loading="loading_available_employees"
            :disabled="loading || loading_employees_action"
            multiple
            chips
            small-chips
            deletable-chips
            clearable
            hide-details
            class="mr-3"
          ></v-autocomplete>
          <v-btn
            color="primary"
            small
            class="mr-2"
            :disabled="loading || loading_employees_action || (selected_employee_ids || []).length == 0"
            :loading="loading_employees_action"
            @click="addEmployees"
          >
            <v-icon left small>mdi-account-multiple-plus</v-icon>
            Adicionar
          </v-btn>
          <v-btn
            color="error"
            small
            outlined
            :disabled="loading_employees_action"
            @click="cancelEdit"
          >
            Cancelar
          </v-btn>
        </template>
        <v-btn
          v-else
          color="primary"
          small
          :disabled="loading"
          @click="startEdit"
        >
          <v-icon left small>mdi-pencil</v-icon>
          Editar
        </v-btn>
      </v-card-title>
      <v-data-table
        mobile-breakpoint="1"
        :items="employees"
        :headers="table_headers"
        :loading="loading"
        :items-per-page="5"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                small
                color="error"
                :disabled="loading_employees_action"
                @click="confirmRemoveEmployee(item)"
              >
                <v-icon small>mdi-account-remove</v-icon>
              </v-btn>
            </template>
            <span>Remover funcionário do módulo</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'ShowDepotEmployees',
  data() {
    return {
      key: null,
      header: [
        { text: 'Nome', value: 'attributes.name', width: '70%' },
        { text: 'Cargo', value: 'attributes.role.data[0].attributes.translated'}
      ],
      loading: false,
      loading_employees_action: false,
      loading_available_employees: false,
      editing: false,
      employees: [],
      all_employees: [],
      selected_employee_ids: [],
    }
  },
  methods: {
    getEmployees(id){
      this.loading = true

      Api.Employee.index({modality_ids: [this.$route.params.id]}).then(r=>{
        this.employees = r.data.data
      }).catch(err=>{
        console.log({err});
      }).finally(() => {
        this.loading = false
      })
    },
    getAvailableEmployees(){
      this.loading_available_employees = true

      Api.Employee.index({short: true}).then(r=>{
        this.all_employees = r.data.data
      }).catch(err=>{
        console.log({err});
      }).finally(() => {
        this.loading_available_employees = false
      })
    },
    startEdit(){
      this.editing = true
      this.$emit('editing', true)
      if (!this.all_employees.length){
        this.getAvailableEmployees()
      }
    },
    cancelEdit(){
      this.selected_employee_ids = []
      this.editing = false
      this.$emit('editing', false)
    },
    addEmployees(){
      this.loading_employees_action = true
      Api.Modality.addEmployees(this.$route.params.id, this.selected_employee_ids).then(response => response.data).then(data => {
        let added_count = data.added_count || 0
        let msg = added_count > 0
          ? `${added_count} funcionário(s) adicionado(s) ao módulo.`
          : 'Os funcionários selecionados já estavam neste módulo.'

        this.addNotification({type: 'success', msg})
        this.cancelEdit()
        this.getEmployees()
      }).catch(err => {
        this.addNotification({type: 'error', msg: 'Erro ao adicionar funcionários ao módulo.'})
        console.log(err)
      }).finally(() => {
        this.loading_employees_action = false
      })
    },
    confirmRemoveEmployee(employee){
      const employee_name = employee?.attributes?.name || 'este funcionário'

      this.swallConfirmation({
        title: `Deseja remover ${employee_name} deste módulo?`,
        icon: 'warning',
      }).then(confirmed => {
        if (confirmed) {
          this.removeEmployee(employee.id)
        }
      })
    },
    removeEmployee(employee_id){
      this.loading_employees_action = true
      Api.Modality.removeEmployees(this.$route.params.id, [employee_id]).then(response => response.data).then(data => {
        let removed_count = data.removed_count || 0
        let msg = removed_count > 0
          ? `${removed_count} funcionário(s) removido(s) do módulo.`
          : 'O funcionário selecionado não estava neste módulo.'

        this.addNotification({type: 'success', msg})
        this.getEmployees()
        this.getAvailableEmployees()
      }).catch(err => {
        this.addNotification({type: 'error', msg: 'Erro ao remover funcionário do módulo.'})
        console.log(err)
      }).finally(() => {
        this.loading_employees_action = false
      })
    },
  },
  computed: {
    available_employees(){
      let employeeIds = this.employees.map(employee => String(employee.id))
      return this.all_employees.filter(employee => !employeeIds.includes(String(employee.id)))
    },
    table_headers(){
      if (!this.editing) {
        return this.header
      }

      return [
        ...this.header,
        { text: 'Ações', value: 'actions', align: 'center', sortable: false, width: '80px' },
      ]
    },
  },
  mounted () {
    this.getEmployees();
  },
}
</script>

<style scoped>

</style>
